export function featuredPosts() {

  // const mediaPosts = document.querySelectorAll('.wp-block-post.media_article');

  // if (mediaPosts.length) {

  //   mediaPosts.forEach((mediaPost) => {

  //     const link = mediaPost.querySelector('.wp-block-post-title a');
  //     console.log(link.getAttribute('href'));

  //     const org_html = mediaPost.querySelector('.feature-image').innerHTML;
  //     const new_html = "<a href="+link.getAttribute('href')+">" + org_html + "</a>";
  //     mediaPost.querySelector('.feature-image').innerHTML = new_html;

  //   });

  // }

  // const featuredPosts = document.querySelectorAll('.wp-block-post.has-post-thumbnail');

  // if (featuredPosts.length) {

  //   featuredPosts.forEach((featuredPost) => {

  //     const link = featuredPost.querySelector('.wp-block-post-title a');

  //     const org_html = featuredPost.querySelector('.wp-block-post-featured-image').innerHTML;
  //     const new_html = "<a href="+link.getAttribute('href')+">" + org_html + "</a>";
  //     featuredPost.querySelector('.wp-block-post-featured-image').innerHTML = new_html;

  //   });

  // }

}